import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  Paper,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import { FaEye, FaPencilAlt } from "react-icons/fa";

const DataTable = ({
                     data,
                     allData,
                     selected,
                     selectAllMode,
                     onSelectionChange,
                     totalCount,
                     page,
                     rowsPerPage,
                   }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelect = (event, id) => {
    const newSelected = new Set(selected);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    onSelectionChange(newSelected, selectAllMode);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // Enter select-all mode
      onSelectionChange(new Set(), true);
    } else {
      // Exit select-all mode
      onSelectionChange(new Set(), false);
    }
  };

  const isSelected = (id) => {
    if (selectAllMode) {
      return !selected.has(id); // In select-all mode, selected Set contains EXCLUDED items
    }
    return selected.has(id);
  };

  const isHeaderCheckboxIndeterminate = () => {
    return !selectAllMode && selected.size > 0 && selected.size < data.length;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
      <>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow className="bg-primary">
                {/*<TableCell padding="checkbox">*/}
                {/*  <Checkbox*/}
                {/*      color="primary"*/}
                {/*      indeterminate={isHeaderCheckboxIndeterminate()}*/}
                {/*      checked={selectAllMode || selected.size > 0}*/}
                {/*      onChange={handleSelectAll}*/}
                {/*  />*/}
                {/*</TableCell>*/}
                {["id", "name", "subject", "status", "total_recipients", "sent_count", "open_count", "click_count", "failed_count", "started_at", "completed_at"].map((column) => (
                    <TableCell
                        key={column}
                        align="center"
                        className="!text-darkTextColor whitespace-nowrap"
                    >
                      <TableSortLabel
                          active={orderBy === column}
                          direction={orderBy === column ? order : "asc"}
                          onClick={() => handleSort(column)}
                      >
                        {column === "email_verified_at" ? "Verify at" : column}
                      </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell
                    align="center"
                    className="!text-darkTextColor whitespace-nowrap"
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item) => {
                const isItemSelected = isSelected(item.id);
                return (
                    <TableRow
                        key={item.id}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        hover
                        selected={isItemSelected}
                    >
                      {/*<TableCell padding="checkbox">*/}
                      {/*  <Checkbox*/}
                      {/*      color="primary"*/}
                      {/*      checked={isItemSelected}*/}
                      {/*      onChange={(event) => handleSelect(event, item.id)}*/}
                      {/*  />*/}
                      {/*</TableCell>*/}
                      <TableCell component="th" scope="row" align="center">
                        {item?.id}
                      </TableCell>
                      <TableCell align="center">{item?.name}</TableCell>
                      <TableCell align="center">{item?.subject}</TableCell>
                      <TableCell align="center">
                    <span
                        className={`badge w-24 text-darkTextColor ${
                            item?.status === 'completed'
                                ? "bg-[#28a745]"
                                : item?.status === 'sending' 
                                ? "bg-[#3f78e0]"
                                : item?.status === 'queued' 
                                ? "bg-[#ab7328]"  
                                : item?.status === 'draft' 
                                ? "bg-[#757575]" 
                                    :"bg-[#ff6877]"
                        }`}
                    >
                      {item?.status}
                    </span>
                      </TableCell>
                      <TableCell align="center">{item?.total_recipients}</TableCell>
                      <TableCell align="center">{item?.sent_count}</TableCell>
                      <TableCell align="center">{item?.open_count}</TableCell>
                      <TableCell align="center">{item?.click_count}</TableCell>
                      <TableCell align="center">{item?.failed_count}</TableCell>
                      <TableCell align="center">{item?.started_at}</TableCell>
                      <TableCell align="center">{item?.completed_at}</TableCell>
                      <TableCell align="center">
                        <div className="flex gap-x-10 text-lg items-center justify-center">
                          <Link
                              to={`/campaigns/${item?.id}`}
                              color="inherit"
                              underline="none"
                              className="flex items-center justify-center"
                          >
                            <FaEye className="text-[#6c757d]" />
                          </Link>
                        </div>
                      </TableCell>
                    </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
  );
};

export default DataTable;




